module.exports = __webpack_public_path__ + "img/logoprescription.d4c5025d.png";